// Stamped at image build (Dockerfile ARG -> VITE_*); "dev" locally.
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION ?? "dev";
export const BUILD_SHA: string = import.meta.env.VITE_BUILD_SHA ?? "dev";
